import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Link, { linkBase } from '@src/mobile/components/Link';
import { useMaximize } from '@src/public/hooks/app';
import { isGrounds } from '@src/public/utils/app';
import { RankStore } from '../store';
import { getHotRank } from '../service';
import styles from './index.css';
import Header from './Header';

const cx = classNames.bind(styles);

const Rank = () => {
    const rankStore = RankStore.useContainer();
    const { rankStates, changeRankStates } = rankStore;
    const { list } = rankStates;

    const statusBarHeight = useMaximize();

    useEffect(() => {
        getHotRank().then(res => {
            if (res && Array.isArray(res) && res.length) {
                changeRankStates({ list: res });
            }
        });
    }, []);

    return (
        <div className={styles.wrap}>
            {isGrounds ? <Header statusBarHeight={statusBarHeight} /> : null}
            <div className={styles.list}>
                {list.slice(0, 10).map((item, index) => {
                    const { id, title, label } = item;
                    let labelType = '';

                    if (label === '新') {
                        labelType = 'labelNew';
                    } else if (label === '热') {
                        labelType = 'labelHot';
                    }

                    return (
                        <div className={styles.item} key={id}>
                            <div className={cx('rank', `rank${index + 1}`)} />
                            <div className={styles.title}>
                                <Link to={`${linkBase}/loc/timeline/event/${id}?ref=timeline_merge`}>{title}</Link>
                            </div>
                            {label ? <div className={cx('label', labelType)} /> : null}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default errorBoundary(Rank);
